import Choices from 'choices.js'
import api from '@/plugins/api'
import lang from '@/plugins/lang'
import './lang'
import parser from '@/helpers/parser'

// Injeção de uma função para auxiliar no reset de width do placeholder, para que não aparça o placeholder
// ao ter um item ou mais nos casos de multi-select
Choices.prototype.resetPlaceholder = function() {
    if (this._isSelectMultipleElement && this._placeholderValue) {
        let { length } = this.passedElement.element.selectedOptions

        if (length > 0) {
            this.input.element.placeholder = ''
            this.input.element.style.minWidth = '0px'
        } else {
            this.input.element.placeholder = this._placeholderValue
            this.input.element.style.minWidth = this._placeholderValue.length + 'ch'
        }
    }
}

// Wraper da função disable para que seja possível mostrar o placeholder do disable corretamente caso no select tenha
// sido informado pelo dataset data-disable-placeholder
const originalDisable = Choices.prototype.disable
Choices.prototype.disable = function() {
    let ret = originalDisable.call(this)

    let disablePlaceholder = this.passedElement.element.dataset.disabledPlaceholder

    if (!disablePlaceholder) {
        return ret
    }

    if(this._isSelectOneElement) {
        // É necessário usar um timeout por conta de um evento que é chamado pela _store do choice.js ao remover
        // algum item da store e resetar o placeholder, fazendo com que duplique o placeholder.
        // OBS: o evento da _store é uma promise, então o código inteiro será executado para depois o evento ser executado
        // então é usado um setTimeout para deixar o evento ser executado e depois sobrescrevemos o placeholder.
        setTimeout(() => {
            if(!this.containerOuter.isDisabled) {
                return
            }

            let placeholderItem = this.itemList.getChild(`.${this.config.classNames.placeholder}`)
            if (!placeholderItem) {
                placeholderItem = this._getTemplate('placeholder', disablePlaceholder)
                this.itemList.append(placeholderItem)
            } else {
                placeholderItem.innerHTML = parser.entityHtml(disablePlaceholder)
            }
        }, 100)

    } else {
        this.input.element.placeholder = disablePlaceholder
        this.input.element.style.minWidth = disablePlaceholder.length + 'ch'
    }

    return ret
}

Choices.prototype._onFormReset = function() {
    if (this._isSelectMultipleElement) {
        this.removeActiveItems()
        this.resetPlaceholder()
    } else {
        if (! this.initialDisabled) {
            this.setChoiceByValue('')
        } else {
            this.removeActiveItems()
        }
    }

    if (this.initialDisabled) {
        this.disable()
    }

    if (this.passedElement.element.classList.contains('choices-search-js')) {
        this._isSearching = false;
        this.clearChoices()
    }
}

const listChoices = []

function createChoice(item, options) {
    let defaultOptions = {
        removeItemButton: true,
        shouldSort: false,
        loadingText: lang.t('searching'),
        searchResultLimit: 15,
        allowHTML: true,
        ...options,
    }

    let choice = new Choices(item, defaultOptions)

    item.addEventListener('showDropdown' , function () {
        // Caso o dropdown seja flip (posicionado para cima, invés de pra baixo)
        // Limita o height do dropdown para não ultrapassar o topo da tela e cortar parte do dropdown
        if (choice.containerOuter.isFlipped) {
            let dropdownTopPos = choice.dropdown.element.getBoundingClientRect().top

            if (dropdownTopPos < 0) {
                choice.dropdown.element.style.maxHeight = (choice.dropdown.element.offsetHeight + dropdownTopPos - 5).toString() + 'px'
            }
        }
    })

    item.addEventListener('hideDropdown' , function () {
        choice.dropdown.element.style.maxHeight = null
    })

    if (item.multiple) {

        if (choice.passedElement.element.selectedOptions.length > 0) {
            choice.input.element.placeholder = ''
            choice.input.element.style.minWidth = '0px'
        }

        choice.passedElement.element.addEventListener('change', function() {
            choice.resetPlaceholder()
        });
    }

    if (item.disabled) {
        choice.initialDisabled = true
    }

    listChoices.push(choice)

    return choice
}

document.querySelectorAll('.choices-js').forEach(item => {
    createChoice(item)
})

document.querySelectorAll('.choices-search-js').forEach(item => {
    let choice = createChoice(item, {
        noChoicesText: '<i class="fas fa-magnifying-glass mr-2"></i>' + item.dataset.searchPlaceholder
    })

    let spinner = document.createElement('div')
    spinner.className = 'spinner-border spinner-border-sm text-primary mr-2'

    let loading = document.createElement('div')
    loading.className = 'choices__item choices__item--choice'
    loading.append(spinner, lang.t('choicesjs:apiSearching'))

    choice._handleSearch = function(value) {
        value = value.trim()

        this._isSearching = !!value;

        if (value) {
            this.passedElement.triggerEvent('search', { value, choice: this });
        }
    }

    choice.input.element.addEventListener('keyup', function(event) {
        if (event.target.value) {
            return
        }

        if (choice._isSelectMultipleElement) {
            choice.clearChoices()
            return
        }

        const placeholder = choice._store.placeholderChoice

        if (placeholder) {
            choice.setChoices([
                { ...placeholder },
            ], 'value', 'label', true)
        } else {
            choice.clearChoices()
            choice.choiceList.clear()
        }

        choice.choiceList.append(choice._getTemplate('notice', choice.config.noChoicesText, 'no-choices'))
    })

    if (choice._isSelectOneElement) {
        choice.choiceList.append(choice._getTemplate('notice', choice.config.noChoicesText, 'no-choices'))
    }

    choice.startLoadingAPI = function() {
        if (! loading.parentElement) {
            this.choiceList.clear()
            this.choiceList.append(loading)
        }
    }

    choice.stopLoadingAPI = function() {
        this.choiceList.clear()
    }
})

document.querySelectorAll('.choices-js[data-unique-choice], .choices-search-js[data-unique-choice]')
    .forEach(item => bindUniqueChoice(item))

/**
 * @param {Choices|Choices[]} choices
 * @param {string} url
 * @param {(function(item: Object): Object) | (function(item: Object): Object)[]} cbMap
 * @param {boolean} replace
 * @param {boolean} keepSelected
 * @param {Object} [params]
 * @returns {Promise<Choices>}
 */
function fetchChoiceAPI(choices, url, cbMap, { replace = true, keepSelected = true, params } = {}) {
    let promise = api(url, { data: params })

    choices = Array.isArray(choices) ? choices : [choices]

    let responses = choices.map((choice, index) => {
        let selectds = keepSelected ? choice.getValue(true) : null

        choice.removeActiveItems(null)

        const callback = Array.isArray(cbMap) ? cbMap[index] : cbMap

        let placeholderChoice = null

        if (choice._isSelectOneElement) {
            let placeholder = choice._store.placeholderChoice

            if (placeholder) {
                placeholderChoice = {
                    value: placeholder.value,
                    label: placeholder.label,
                    selected: placeholder.selected,
                    disabled: placeholder.disabled,
                    placeholder: true,
                }
            }
        }

        return choice.setChoices(async () => {
            let data = []

            try {
                data = await promise

                data = data.data || data
            } catch (error) {}

            let choicesToAdd = []

            if (placeholderChoice) {
                choicesToAdd.push(placeholderChoice)
            }

            let hasItemSelected = false

            data.forEach(item => {
                let itemChoice = callback(item)

                if (!itemChoice) {
                    return
                }

                itemChoice.value = itemChoice.value.toString()

                if (itemChoice.selected === undefined && keepSelected) {
                    itemChoice.selected = Array.isArray(selectds) ? selectds.includes(itemChoice.value) : itemChoice.value === selectds
                }

                if (itemChoice.selected) {
                    hasItemSelected = true
                }

                choicesToAdd.push(itemChoice)
            })

            if (!hasItemSelected && placeholderChoice) {
                placeholderChoice.selected = true
            }

            return choicesToAdd
        }, 'value', 'label', replace).then(objChoice => {
            objChoice.resetPlaceholder()

            return objChoice
        })
    })

    return responses.length === 1 ? responses[0] : responses
}

/**
 * @param {HTMLElement} element
 */
function bindUniqueChoice(element) {
    const excludeFromChoice = findChoiceByName(element.dataset.uniqueChoice, element.form.id)

    const choice = findChoiceByName(element.name, element.form.id)

    excludeFromChoice.passedElement.element.addEventListener('change', function(event) {
        let added = !!excludeFromChoice._store.activeItems.find(item => item.value === event.detail.value)

        let isMultiple = excludeFromChoice._isSelectMultipleElement

        let items = choice._store.choices
                .map(item => ({...item, disabled: event.detail.value === item.value ? added : (isMultiple ? item.disabled : false)}))

        if (choice._isSelectMultipleElement) {
            choice.removeActiveItems(null)
        }

        choice.setChoices(items, 'value', 'label', true)

        choice.resetPlaceholder()
    })

    let selecteds = excludeFromChoice.getValue(true)

    selecteds = Array.isArray(selecteds) ? selecteds : [selecteds]

    let items = choice._store.choices.map(item => ({ ...item, disabled: selecteds.includes(item.value) }))

    if (choice._isSelectMultipleElement) {
        choice.removeActiveItems(null)
    }

    choice.setChoices(items, 'value', 'label', true)

    choice.resetPlaceholder()
}

/**
 * @param {string} id
 * @returns {Choices|null}
 */
function findChoiceById(id) {
    return listChoices.find(n => n.passedElement.element.id === id);
}

/**
 * @param {string} className
 * @returns {Choices|null}
 */
function findChoiceByClass(className) {
    return listChoices.find(n => n.passedElement.element.className.includes(className));
}

/**
 * @param {string} inputName
 * @param {string} [formId]
 * @returns {Choices|null}
 */
function findChoiceByName(inputName, formId = undefined) {
    return listChoices.find(n => {
        return n.passedElement.element.name === inputName && (!formId || n.passedElement.element.form.id === formId)
    });
}

/**
 * @param {string} inputName
 * @param {string} [formId]
 * @returns {Choices[]|null}
 */
function getChoicesByName(inputName, formId = undefined) {
    return listChoices.filter(n => {
        return n.passedElement.element.name === inputName && (!formId || n.passedElement.element.form.id === formId)
    });
}

/**
 * @param {Choices} choice
 */
function enableOptions(choice) {
    choice.setChoices(choice._store.choices.map(i => ({
        ...i,
        disabled: false
    })), 'value', 'label', true)
}

export { listChoices, fetchChoiceAPI, findChoiceById, findChoiceByClass, findChoiceByName, getChoicesByName, enableOptions, createChoice }
